import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import * as serviceWorker from './serviceWorker';
import { Router } from "./Containers/Router/Router";
import ReactGA from 'react-ga';

function initializeReactGA() {
    ReactGA.initialize('UA-154925638-1');
}
initializeReactGA();

ReactDOM.render(<Router />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
